/* eslint-disable no-param-reassign */
export const modifiedLabel = (firstName, lastName, username, email) => {
  const namePart = `${firstName || ''} ${lastName || ''}`.trim();
  const usernamePart = username ? `(${username})` : '';

  const emailInfo = email ? ` - ${email}` : '';

  const label = `${namePart}${usernamePart}${emailInfo}`;

  return label.length > 80 ? `${label.slice(0, 80)}...` : label;
};

export const returnModifiedOptions = (list) =>
  list.map((ele) => {
    ele.value = ele.id?.toString();
    ele.label = `${modifiedLabel(
      ele.firstname,
      ele.lastname,
      ele.username,
      ele.email
    )}`;
    ele.isChecked = false;

    return ele;
  });

export const isEmptyObject = (obj) => Object.keys(obj).length === 0;
